import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { initedPromise } from "@/lib/auth";
const emptyLayout = () => import("@/components/layout/base/empty");

Vue.use(Router);

/**
interface configItem{
    priority: number; // 权重值
    component?: VueCompontent | () => VueComponent; // 页面组件，不设置会默认使用空层
    menu?: { // 菜单数据
        title: string | VueComponent | () => string; | () => VueComponent // 菜单栏标题
        icon: string // 显示 icon，使用 element-ui icon
        i18n: boolean // 是否将 title 的 string 用 vue-i18n 来解析
    },
    permit?: string | number; // 要求的权限
    children?: configItem[]; // 子页面，数组顺序影响页面在菜单上展示的顺序
    meta: object; // 页面数据
    setup?: () => configItem; // 掉用哪个后获取到 configItem，注意会覆盖上面的 component, menu, meta, children
    path: string; // 路径
}
 */
export const config = parse(
    [
        { path: "/" }, // 留个入口为空白页
        {
            path: "password/reset",
            component: () => import("@/views/password/ResetPassword.vue")
        },
        {
            path: "knowledge",
            permit: "knowledge",
            menu: { title: "zhiji.menu.knowledge", icon: "el-icon-s-management", i18n: true },
            name: "knowledge",
            component: () => import("@/views/zhiji/pages/ServicePage.vue"),
            children: [
                {
                    path: "questionlist",
                    permit: "knowledge.fqamanager",
                    menu: { title: "zhiji.menu.questionManager", i18n: true },
                    name: "questionlist",
                    component: () => import("@/views/zhiji/pages/knowlege/QuestionListPage.vue")
                },
                {
                    path: "firstrecom",
                    permit: "knowledge.firstscreen",
                    menu: { title: "zhiji.menu.firstRecom", i18n: true },
                    name: "firstrecom",
                    component: () => import("@/views/zhiji/pages/firstrecom/FirstRecommend.vue")
                },
                {
                    path: "QAMatchingTest",
                    permit: "knowledge.quesAndAnswer",
                    menu: { title: "zhiji.menu.QAMatchingTest", i18n: true },
                    name: "QAMatchingTest",
                    component: () => import("@/views/zhiji/pages/onlineQATest/QAMatchingTest.vue")
                },
                {
                    path: "wikipagesetting",
                    permit: "knowledge.wikipage",
                    menu: { title: "zhiji.menu.wiki", i18n: true },
                    name: "wikipagesetting",
                    component: () => import("@/views/zhiji/pages/wikiPage/WikiPage.vue")
                },
                {
                    path: "cluster",
                    menu: { title: "zhiji.menu.questionCluster", i18n: true },
                    permit: "knowledge.questioncluster",
                    name: "cluster",
                    component: () => import("@/views/zhiji/pages/cluster/QuestionClusterPage.vue")
                },
                {
                    path: "picture",
                    menu: { title: "zhiji.menu.picture", i18n: true },
                    permit: "knowledge.pictures",
                    name: "picture",
                    component: () => import("@/views/zhiji/pages/picture/PictureLibraryPage.vue")
                },
                {
                    path: "video",
                    menu: { title: "zhiji.menu.video", i18n: true },
                    permit: "knowledge.videos",
                    name: "video",
                    component: () => import("@/views/zhiji/pages/video/VideoLibraryPage.vue")
                },
                {
                    path: "guides",
                    menu: { title: "zhiji.menu.guides", i18n: true },
                    permit: "knowledge.tips",
                    name: "guides",
                    component: () => import("@/views/zhiji/pages/guides/GuidesLibraryPage.vue")
                }
            ]
        },
        {
            path: "im",
            permit: "titan.im",
            menu: { title: "IM工作台", icon: "el-icon-user" },
            redirect: "/titan/index.html#/im"
        },
        {
            path: "imticket",
            permit: "titan.ticket",
            menu: { title: "ticket.menu.self", i18n: true, icon: "el-icon-s-order" },
            redirect: "/titan/index.html#/ticket/all"
        },
        {
            path: "ticket",
            permit: "ticket",
            menu: { title: "ticket.menu.self", i18n: true, icon: "el-icon-s-order" },
            setup: require("@/views/ticket/router").default
        },
        // 机器人数据分析"all.menu.dataAnalysis"
        {
            path: "analysisrobot",
            permit: "analysisrobot",
            menu: { title: "all.menu.robotAnalysis", icon: "el-icon-s-data", i18n: true },
            name: "analysisrobot",
            component: () => import("@/views/zhiji/pages/ServicePage.vue"),
            children: [
                {
                    path: "robot",
                    menu: { title: "all.menu.dataOverview", i18n: true },
                    permit: "analysisrobot.overview",
                    name: "robot",
                    component: () => import("@/views/zhiji/pages/dataOverview/DataOverviewPage.vue")
                },
                {
                    path: "hotSpotAnaly",
                    menu: { title: "zhiji.menu.hotSpotAnaly", i18n: true },
                    name: "hotSpotAnaly",
                    permit: "analysisrobot.hot",
                    component: () => import("@/views/zhiji/pages/hotSpotAnaly/HotSpotAnalysis.vue")
                },
                {
                    path: "robotDialogLog",
                    menu: { title: "zhiji.menu.robotLog", i18n: true },
                    permit: "analysisrobot.log",
                    name: "robotDialogLog",
                    component: () => import("@/views/zhiji/pages/robotDialogLog/AskAnswerLogPage.vue")
                },
                {
                    path: "likeDisplaySatisfaction",
                    menu: { title: "zhiji.menu.likeDisplaySatisfaction", i18n: true },
                    name: "likeDisplaySatisfaction",
                    permit: "analysisrobot.satisfy",
                    component: () => import("@/views/zhiji/pages/likeDisplaySatisfaction/Page.vue")
                },
            ]
        },
        // 工单数据分析
        {
            path: "analysisticket",
            permit: "analysisticket",
            menu: { title: "all.menu.ticketAnalysis", icon: "el-icon-s-data", i18n: true },
            name: "analysisticket",
            children: [
                {
                    path: "overview",
                    permit: "analysisticket.overview",
                    menu: { title: "all.menu.ticketOverview", i18n: true },
                    component: () => import("@/views/data/ticket")
                },
                {
                    path: "tickethot",
                    permit: "analysisticket.hot",
                    menu: { title: "data.ticket.hottitle", i18n: true },
                    component: () => import("@/views/data/hot")
                },
                {
                    path: "ticketSatis",
                    permit: "analysisticket.satisfy",
                    menu: { title: "data.ticket.ticketSatisfaction", i18n: true },
                    component: () => import("@/views/data/satisfact")
                },
                {
                    path: "ticket",
                    menu: { title: "log.ticket.mTitlea", i18n: true },
                    permit: "analysisticket.perform",
                    name: "ticket",
                    component: () => import("@/views/log/ticket")
                }
            ]
        },
        {
            path: "zhijiservice",
            permit: "autosys",
            menu: { title: "自动化系统", icon: "el-icon-s-opportunity" },
            component: () => import("@/views/zhiji/pages/ServicePage.vue"),
            children: [
                {
                    path: "rpaedit",
                    permit: "autosys.manager",
                    name: "rpaedit",
                    component: () => import("@/views/zhiji/pages/rpaFlow/index.vue")
                },
                {
                    path: "rpalist",
                    permit: "autosys.manager",
                    menu: { title: "RPA管理" },
                    name: "rpalist",
                    component: () => import("@/views/zhiji/pages/rpaList/Page.vue")
                }
            ]
        },
        {
            path: "settings",
            menu: { title: "all.menu.settings", icon: "el-icon-s-tools", i18n: true },
            component: () => import("@/views/zhiji/pages/ServicePage.vue"),
            name: "settings",
            children: [
                {
                    path: "userManager",
                    permit: "system.usermanager",
                    menu: { title: "zhiji.menu.userManager", i18n: true },
                    name: "userManager",
                    component: () => import("@/views/zhiji/pages/personnel/PersonManagePage.vue")
                },
                {
                    path: "portraitParams",
                    menu: { title: "zhiji.menu.portraitParams", i18n: true },
                    permit: "system.portraitParams",
                    name: "portraitParams",
                    component: () => import("@/views/zhiji/pages/portraitParams/PortraitParams.vue")
                },
                {
                    path: "portraitTags",
                    menu: { title: "zhiji.menu.portraitTags", i18n: true },
                    permit: "system.portraitTags",
                    name: "portraitTags",
                    component: () => import("@/views/zhiji/pages/portraitTags/portraitTags.vue")
                },
                {
                    path: "formManager",
                    permit: "system.formmanager",
                    menu: { title: "zhiji.menu.formManager", i18n: true },
                    name: "formManager",
                    component: () => import("@/views/zhiji/pages/form/FormManagePage.vue")
                },
                {
                    path: "statement",
                    menu: { title: "statement.menu", i18n: true },
                    permit: "system.quickreplies",
                    name: "statement",
                    component: () => import("@/views/statement/index.vue")
                },
                {
                    path: "sensitiveWord",
                    menu: { title: "zhiji.menu.sensitiveWord", i18n: true },
                    permit: "system.sensitiveword",
                    name: "sensitiveWord",
                    component: () => import("@/views/zhiji/pages/sensitiveWord/SensitiveWordManage.vue")
                },
                {
                    path: "entityManagement",
                    permit: "system.entityManagement",
                    menu: { title: "实体管理" },
                    name: "entityManagement",
                    component: () => import("@/views/zhiji/pages/entityManagement/EntityManagement.vue")
                },
                {
                    path: "businesssetting",
                    menu: { title: "zhiji.menu.businessSet", i18n: true },
                    permit: "business.settings",
                    name: "businesssetting",
                    component: () => import("@/views/zhiji/pages/businessSetting/Page.vue")
                },
                {
                    path: "modulesetting",
                    menu: { title: "zhiji.menu.moduleSet", i18n: true },
                    permit: "admin.moduleconfig",
                    name: "modulesetting",
                    component: () => import("@/views/zhiji/pages/moduleSetting/Page.vue")
                },
                {
                    path: "answerComponentManager",
                    menu: { title: "zhiji.menu.answerComponentManager", i18n: true },
                    permit: "system.answerConfig",
                    name: "answerComponentManager",
                    component: () => import("@/views/zhiji/pages/answerComponent/ManagerPage.vue")
                },
            ]
        }
    ].concat([
        {
            path: "*",
            component: () => import("@/views/404")
        }
    ])
);

function getPriority({ priority = 0 } = {}) {
    return priority;
}

function parse(input) {
    const isArray = Array.isArray(input);
    const list = isArray ? input : [input];
    list.sort((a, b) => getPriority(b) - getPriority(a));
    const result = list.map(one => {
        const { path = "", name, component = emptyLayout, meta, menu, children, setup, permit, redirect } = one;
        const more = setup && setup();

        return {
            name,
            component,
            meta: { ...meta, title: (menu || {}).title, permit },
            menu,
            permit,
            children: children && parse(children),
            ...more,
            path: path.replace(/^\/*|\/*$/g, "").trim() || "/",
            redirect
        };
    });
    return isArray ? result : result[0];
}

const router = new Router({
    routes: [
        // 格式请参考上面的 configItem 说明
        {
            path: "/",
            component: () => import("@/components/layout/base"),
            children: config
        }
    ]
});

router.beforeEach((to, _, next) => {
    initedPromise.then(() => {
        if (!to.meta.permit || store.state.auth.permit.includes(to.meta.permit)) {
            next();
        } else if (store.state.auth.permit.includes("knowledge.fqamanager")) {
            next("/knowledge/questionlist");
        } else {
            next("/");
        }
    });
});
export default router;
